import { Rule } from 'antd/lib/form';
import useTranslation from 'next-translate/useTranslation';

type TOptions = {
  name: string;
  required?: boolean;
}

export const useShortTextValidationRules = (opts: TOptions): Rule[] => {
  const { t } = useTranslation();
  return [
    ...(opts.required ? [{
      required: true,
      message: t('validation:required', { field: opts.name })
    }] : []),
    { type: 'string', max: 200, message: t('validation:toolong', { field: opts.name, limit: 200 }) }
  ];
}